export default __webpack_public_path__ + "d61f43374c854ab8506406aca1f6c76e.svg";